//////////////////
// IMPORTS
//////////////////
// schema
// import * as ISchema from '@schema';
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// defrag daily results card imports
import { IProps } from "./TailoredDefragSummaryEventMoved.d";
import * as s from "./TailoredDefragSummaryEventMoved.styles";
import { fragments } from "./TailoredDefragSummaryEventMoved.gql";
// other components
import { H3 } from "@ui";
// util
import { removeAutopilotEmoji } from "@util/event.util";
import { getAbsoluteDateTimeForMoveHistory } from "@clockwise/client-commons/src/util/format-time";
// material-ui
import AccessTime from "@material-ui/icons/AccessTime";
import MeetingRoom from "@material-ui/icons/MeetingRoom";
import Check from "@material-ui/icons/Done";

//////////////////
// COMPONENT
//////////////////
const TailoredDefragSummaryEventMovedCmpt = ({ eventMoved, rooms }: IProps) => {
  // sanity
  if (!eventMoved.event) {
    return null;
  }

  const { newTime } = getAbsoluteDateTimeForMoveHistory(eventMoved);
  const title = removeAutopilotEmoji(eventMoved.event.title);
  const showRooms =
    eventMoved.addedRooms &&
    eventMoved.addedRooms.length &&
    rooms &&
    rooms.list &&
    rooms.list.length;

  const addedRooms: string[] = [];
  showRooms &&
    eventMoved.addedRooms.forEach((roomId) => {
      const room = rooms && rooms.list.find((r) => r.roomId === roomId);
      if (room && room.name) {
        addedRooms.push(room.name);
      }
    });

  return (
    <div style={{ ...s.container, borderBottom: s.borderBottom }}>
      <H3>{title}</H3>
      <div style={s.row}>
        <AccessTime style={s.icon} />
        <div style={s.text}>{newTime}</div>
      </div>
      {addedRooms.map((room, i) => {
        return (
          <div style={s.row} key={i}>
            <MeetingRoom style={s.icon} />
            <div style={s.text}>{room}</div>
          </div>
        );
      })}
      {eventMoved.moveReasons.map((reason, i) => {
        return (
          <div style={s.row} key={i}>
            <Check style={s.icon} />
            <div style={s.reason}>{reason}</div>
          </div>
        );
      })}
    </div>
  );
};

//////////////////
// RELAY
//////////////////
export const TailoredDefragSummaryEventMoved = createFragmentContainer(
  TailoredDefragSummaryEventMovedCmpt,
  fragments,
);
